import axios from 'axios';
import store from '@/store'; // Importa el store para acceder al token

// Crear una instancia de Axios
const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL || 'https://api.servicetrack.com.ar/api', // Cambiar por la URL de tu API
    //baseURL: process.env.VUE_APP_API_URL || 'http://posventa.test/api', // Cambiar por la URL de tu API
    timeout: 10000, // Tiempo de espera de las solicitudes (10 segundos)
    headers: {
        'Content-Type': 'application/json', // Tipo de contenido por defecto
    },
});

// Interceptor para incluir el token de autenticación en cada solicitud
instance.interceptors.request.use(
    (config) => {
        const token = store.getters['auth/getToken']; // Obtén el token desde el store
        if (token) {
            config.headers.Authorization = `Bearer ${token}`; // Agrega el token al encabezado Authorization
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor para manejar errores globalmente
instance.interceptors.response.use(
    (response) => response, // Retorna la respuesta si es exitosa
    (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                // Si el token es inválido o ha expirado, realiza un logout
                //store.dispatch('auth/logout');
                //window.location.href = '/login'; // Redirige al login
            }
        }
        return Promise.reject(error); // Rechaza la promesa con el error
    }
);

export default instance;
